import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const MappingChartsDataContext = createContext();

const MappingChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_MAPPING,
            url: 'governanceroom/esus/production/mapping'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              evolutionTeam: data?.evolutionTeam ?? []
          }
        : {
              evolutionTeam: []
          };

    return (
        <MappingChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </MappingChartsDataContext.Provider>
    );
};

export default MappingChartsDataProvider;
